import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import { Translation } from 'react-i18next'
import CompanyDetails from './companyDetails'
import { Field, WatchField } from '../../form'
import { searchCompanyDetails, closeCompanyLists } from '../../actions/index'
import store from '../../store'
import { employerSide } from '../../routerHistory'
import mobileView from '../../utils/mobile.utils'

const styles = (theme) => ({
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    fontSize: '14px'
  },
  resize: {
    fontSize: '14px'
  },
  dropDownListsTextField: {
    position: 'relative'
  },
  dropDownLists: {
    position: 'absolute',
    width: '100%',
    zIndex: 3,
    background: '#f9f9f9'
  }
})

const CompanySearchField = ({ name, control, disabled, ...rest }) => {
  return (
    <WatchField fields={name} control={control}>
      {(fields) => (
        <Search
          name={name}
          searchValue={fields[name]}
          control={control}
          disabled={disabled}
          {...rest}
        />
      )}
    </WatchField>
  )
}

const Search = ({ classes, name, form, searchValue, control, disabled }) => {
  const location = store.getState().router.location.pathname
  const apiSuccess = useSelector((state) => state.companyLists.apiSuccess)
  const companySelected = useSelector(
    (state) => state.companyLists.companySelected
  )
  const dispatch = useDispatch()

  const [isFocused, setIsFocused] = React.useState(false)

  useEffect(() => {
    if (!companySelected && searchValue.toString().length > 1 && isFocused) {
      dispatch(searchCompanyDetails(searchValue))
    } else dispatch(closeCompanyLists())
  }, [searchValue])

  return (
    <Translation>
      {(t) => (
        <div className={classes.dropDownListsTextField}>
          <Field
            name={name}
            inputType="textfield"
            label={
              employerSide
                ? t('employer.register.name')
                : location !== '/dashboard/openforwork/assignments' &&
                  location !== '/dashboard/openforwork/applications' &&
                  location !== '/dashboard/openforwork/workShifts'
                ? t('asiakkaat.label2')
                : t('assignment.label10')
            }
            labelStyle={{
              marginTop: mobileView ? '19px' : null
            }}
            className={classNames(classes.textField, classes.resize)}
            autoComplete="no"
            setIsFocused={setIsFocused}
            control={control}
            disabled={disabled}
          />
          <div className={classes.dropDownLists}>
            {apiSuccess && <CompanyDetails formName={form} />}
          </div>
        </div>
      )}
    </Translation>
  )
}

export default withStyles(styles)(CompanySearchField)
